const ratingStars = '.feedback .raty-star.write img';
const negativeRatingThreshold = 3;

function alertLowFeedback($feedbackTip) {
  $feedbackTip.slideDown();
}

function removeLowFeedbackAlerts($feedbackTip) {
  $feedbackTip.slideUp();
}

function bindRatingStars() {
  $(document).on('click.ratingStars', ratingStars, function () {
    const $this = $(this);
    const rating = $this.attr('alt');
    const $feedbackTip = $this
      .closest('[data-feedback-order-id]')
      .find('div[data-feedback-tip=true]');

    const $form = $feedbackTip.closest('form');
    $form.find(':submit').prop('disabled', false);
    Reverb.Forms.reEnableDisabledFormSubmit($form);

    if (rating <= negativeRatingThreshold) {
      alertLowFeedback($feedbackTip);
    } else {
      removeLowFeedbackAlerts($feedbackTip);
    }
  });
}

export default {
  init: bindRatingStars,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/feedback_tips.js